import React from "react";
import useIsLoading from "../../../services/hooks/useIsLoading";
import ReportSkeleton from "./ReportSkeleton";

interface ReportTextProps {
  report: string;
  isFormatedReport?: boolean;
}

const ReportText = (props: ReportTextProps) => {
  const { report, isFormatedReport } = props;

  const { isReportLoading } = useIsLoading();

  if (isReportLoading) {
    return <ReportSkeleton isFormattedReport={isFormatedReport} />;
  }

  if (isFormatedReport) {
    return (
      <div className="dui-formatted-report" id="dui-report-text-area-formatted">
        {report}
      </div>
    );
  }
  return (
    <div className="dui-report" id="dui-report-text-area">
      {report}
    </div>
  );
};

export default ReportText;
